<div class="show-div">
  <div class="edit-box" style="border:1px solid #000 ;">
    <div class="titlename" >
      <span>{{"ExcludeVendorEdit"|translate}}</span>
      <em nz-icon [nzType]="'close'" class='close-btn' (click)="onClose()"></em>
    </div>
    <div style="margin-top: 20px;">


    <form nz-form [formGroup]="validateForm">

      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="12">
              <div class="width-100-percent label-font">{{ "Lock" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-select formControlName="Lock" style="width: 180px;">
                <nz-option nzLabel="TRUE" nzValue="TRUE" nzCustomContent>TRUE
                </nz-option>
                <nz-option nzLabel="FALSE" nzValue="FALSE" nzCustomContent>FALSE
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="12">
              <div class="width-100-percent label-font">{{ "Site" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <input nz-input formControlName="Site" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="12">
              <div class="width-100-percent label-font">{{ "table.VendorCode" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <input nz-input formControlName="VendorCode" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="12">
              <div class="width-100-percent label-font">{{"table.VendorName"|translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <input nz-input formControlName="VendorName" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>


      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="12">
              <div class="width-100-percent label-font">{{"ExcludeVendorReason"|translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <textarea (ngModelChange)="getInputvalue($event)" placeholder="{{'ExcludeVendorReasonLimit'|translate}}"
              formControlName="ExcludeVendorReason" style="width:100%; height:100px;overflow-y: auto;"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>


      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="12">
              <div class="width-100-percent label-font">{{'attachment'|translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload" [nzDownload]="onDownload">
                <button nz-button class="upload-button default-button">
                  <em nz-icon nzType="upload"></em>{{'UploadExcel'|translate}}
                </button>
              </nz-upload>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="buttonstyle">
        <div nz-row>
          <div nz-col >
            <span style="width: 50px;"></span>
          </div>
        </div>
        <div nz-row  style="margin-top: 10px;">
          <div nz-col nzSpan="9" [nzPush]="17">
            <button nz-button nzType="default" style="height: 34px;" (click)="onClose()">{{'Cancel'|translate}}</button>
          </div>
          <div nz-col nzSpan="8" [nzPush]="11">
            <button nz-button nzType="primary" [nzLoading]="loading" class="margin-left-10 default-button" [disabled]="IsSaveData()"
              (click)="submitForm($event, validateForm.value)">{{'Save'|translate}}</button>
          </div>

        </div>
      </div>

      <!-- <nz-table nzBordered nzTemplateMode nzBordered="false">
        <tbody>
          <tr>
            <td><nz-form-label>{{"Lock"|translate}}</nz-form-label></td>
            <td>
              <nz-select formControlName="Lock" style="width: 180px;">
                <nz-option nzLabel="TRUE" nzValue="TRUE" nzCustomContent>TRUE
                </nz-option>
                <nz-option nzLabel="FALSE" nzValue="FALSE" nzCustomContent>FALSE
                </nz-option>
              </nz-select>
            </td>
          </tr>
          <tr>
            <td><nz-form-label>{{"Site"|translate}}</nz-form-label></td>
            <td><nz-form-control><input nz-input formControlName="Site" /></nz-form-control></td>
          </tr>
          <tr>
            <td><nz-form-label>{{"table.VendorCode"|translate}}</nz-form-label></td>
            <td><nz-form-control><input nz-input formControlName="VendorCode" /></nz-form-control></td>
          </tr>
          <tr>
            <td><nz-form-label>{{"table.VendorName"|translate}}</nz-form-label></td>
            <td><nz-form-control><input nz-input formControlName="VendorName" /></nz-form-control></td>
          </tr>
          <tr>
            <td><nz-form-label nzRequired>{{"ExcludeVendorReason"|translate}}</nz-form-label></td>
            <td><textarea (ngModelChange)="getInputvalue($event)" placeholder="{{'ExcludeVendorReasonLimit'|translate}}"
                formControlName="ExcludeVendorReason" style="width:100%; height:100px;overflow-y: auto;"></textarea>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <div class="buttonstyle">
        <div nz-row>
          <div nz-col >
            <span style="width: 50px;"></span>
          </div>
        </div>
        <div nz-row  style="margin-top: 16px;">
          <div nz-col nzSpan="6" [nzPush]="1">

            <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload">
              <button nz-button class="upload-button default-button">
                <em nz-icon nzType="upload"></em>*{{' Select File'|translate}}
              </button>
            </nz-upload>



          </div>
          <div nz-col nzSpan="9" [nzPush]="11">
            <button nz-button nzType="default" style="height: 34px;" (click)="onClose()">{{'Cancel'|translate}}</button>
          </div>
          <div nz-col nzSpan="8" [nzPush]="5">
            <button nz-button nzType="primary" class="margin-left-10 default-button" [disabled]="IsSaveData()"
              (click)="submitForm($event, validateForm.value)">{{'Save'|translate}}</button>
          </div>

        </div>
      </div> -->

    </form>
  </div>
  </div>
</div>
